import clsx from 'clsx';
import React from 'react';

import styles from './text.module.scss';

type TextSize = 'large' | 'normal' | 'small';
type FontWeight = 'regular' | 'medium' | 'semibold' | 'bold';
type TextColor = 'light' | 'medium' | 'dark';

interface TextProps {
  size?: TextSize;
  weight?: FontWeight;
  children: React.ReactNode;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  style?: React.CSSProperties;
  color?: TextColor;
}

const colorMap: Record<TextColor, 'colorLight' | 'colorMedium' | 'colorDark'> = {
  light: 'colorLight',
  medium: 'colorMedium',
  dark: 'colorDark'
};

export const Text: React.FC<TextProps> = ({
  size = 'normal',
  weight = 'regular',
  children,
  as = 'p',
  className,
  style,
  color = 'medium'
}) => {
  const Tag = as;

  return (
    <Tag
      className={clsx(
        styles.text,
        styles[size],
        styles[weight],
        styles[colorMap[color]],
        className
      )}
      style={style}
    >
      {children}
    </Tag>
  );
};

export default Text;
